import React from 'react'
import SuperSelect from '../../../hw07/common/c5-SuperSelect/SuperSelect'
import {Pagination} from '@mui/material'
import s from './SuperPagination.module.css'

export type SuperPaginationPropsType = {
    id?: string
    page: number
    itemsCountForPage: number
    totalCount: number
    onChange: (page: number, count: number) => void
}

const SuperPagination: React.FC<SuperPaginationPropsType> = (
    {
        page, itemsCountForPage, totalCount, onChange, id = 'hw15',
    }
) => {
    const lastPage = Math.ceil(totalCount / itemsCountForPage) // пишет студент // вычислить количество страниц

    const onChangeCallback = (event: any, page: number) => {
        // пишет студент
        onChange(page, itemsCountForPage)
    }

    // const onChangeSelect = (event: any) => {
    //     // пишет студент
    //     const newCount = Number(event.currentTarget.value)
    //     // При изменении количества строк переходим на 1 страницу
    //     onChange(1, newCount)
    // }
    //
    const onChangeSelect = (newCount: number) => {  // ← Принимаем число напрямую!
        console.log('Выбрано строк:', newCount)
        onChange(1, newCount)
    }

    return (
        <div className={s.pagination}>
            <Pagination
                id={id + '-pagination'}
                sx={{
                    // стили для Pagination // пишет студент
                    '& .MuiPaginationItem-root': {
                        fontSize: '14px',
                        minWidth: '24px',
                        height: '24px',
                        borderRadius: 0,
                        margin: '0 2px',
                    },
                    '& .MuiPaginationItem-page.Mui-selected': {
                        backgroundColor: '#0066CC',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: '#0052a3',
                        }
                    }
                }}
                page={page}
                count={lastPage}
                onChange={onChangeCallback}
                hideNextButton
                hidePrevButton
            />

            <span className={s.text1}>
                показать
            </span>

            <SuperSelect
                id={id + '-pagination-select'}
                value={itemsCountForPage}
                options={[
                    {id: 4, value: 4},
                    {id: 7, value: 7},
                    {id: 10, value: 10},
                ]}
                onChangeOption={onChangeSelect}
            />

            <span className={s.text2}>
                строк в таблице
            </span>
        </div>
    )
}

export default SuperPagination
